module.exports = __webpack_public_path__ + "static/media/1009001BE.785c4aa8.jpg";